import { Timestamp } from 'firebase/firestore';

// Participant status in a room
export type ParticipantStatus = 'invited' | 'connecting' | 'on_call' | 'left' | 'declined';

// Room status
export type RoomStatus = 'active' | 'ended';

// Participant in a room
export interface RoomParticipant {
  user_uid: string;
  name: string;
  profile_picture: string | null;
  status: ParticipantStatus;
  joined_at: Timestamp | null;
  left_at: Timestamp | null;
}

// Firestore User document
export interface FirestoreUser {
  user_uid: string;
  first_name: string;
  last_name: string;
  profile_picture: string | null;
  designation: string | null;
  is_glass_connected: boolean;
  is_online: boolean;
  current_room_id: string | null; // Track if user is currently on a call
  updated_at: Timestamp;
}

// Incoming call notification data
export interface IncomingCall {
  room_id: string;
  caller_uid: string;
  caller_name: string;
  caller_profile_picture: string | null;
  created_at: Timestamp;
}

// Firestore Room document
export interface FirestoreRoom {
  room_id: string;
  created_at: Timestamp;
  ended_at: Timestamp | null;
  duration_seconds: number | null;
  status: RoomStatus;
  created_by: string;
  created_by_name: string;
  team_uid: string;
  participants: RoomParticipant[];
}

// Input for creating a new room
export interface CreateRoomInput {
  room_id: string;
  created_by: string;
  created_by_name: string;
  created_by_profile_picture: string | null;
  team_uid: string;
  target_user: {
    user_uid: string;
    name: string;
    profile_picture: string | null;
  };
}

// Firestore collection paths
// Structure: remote_assist/data/users/{user_uid}
//            remote_assist/data/rooms/{room_id}
export const COLLECTIONS = {
  ROOT: 'remote_assist',
  ROOT_DOC: 'data',
  USERS: 'users',
  ROOMS: 'rooms',
} as const;

// Helper to get full collection paths
export const getCollectionPath = {
  users: () => `${COLLECTIONS.ROOT}/${COLLECTIONS.ROOT_DOC}/${COLLECTIONS.USERS}`,
  rooms: () => `${COLLECTIONS.ROOT}/${COLLECTIONS.ROOT_DOC}/${COLLECTIONS.ROOMS}`,
} as const;
